<template>
  <div v-if="$route.name === 'Techcenters'">
    <admin-filter
      v-model="filterParams"
    />
    <admin-card>
      <template slot="header">
        Список техцентров
        <router-link
          class="pull-right btn btn-primary btn-sm"
          v-if="currentUser.hasPermission('techcenter.add')"
          :to="{ name: 'TechcenterCreate' }">
          <i class="fa fa-plus"/> Добавить
        </router-link>
      </template>
      <admin-list :items="items" :loading="loading">
        <template slot="headerList">
          <div class="col-6 col-lg-2 d-none d-md-block">Название</div>
          <div class="col-6 col-lg-1 d-none d-md-block">Компания</div>
          <div class="col-6 col-lg-1 d-none d-md-block">Город</div>
          <div class="col-6 col-lg-1 d-none d-md-block">Адрес</div>
          <div class="col-6 col-lg-1 d-none d-md-block">Пользователи</div>
          <div class="col-6 col-lg-1 d-none d-md-block">График работы</div>
          <div class="col-6 col-lg-1 d-none d-md-block">Номер телефона</div>
          <div class="col-6 col-lg-1 d-none d-md-block">Активность</div>
          <div class="col-2 d-none d-lg-block">Действие</div>
          <div class="col-12 d-md-none">Общая информация</div>
        </template>
        <template slot-scope="{ item }">
          <div class="col-12 col-md-6 col-lg-2">
            <router-link :to="{ name: 'Techcenter', params: { id: item.id }}">{{ item.name }}</router-link>
          </div>
          <div class="col-12 col-md-6 col-lg-1">{{ item.company.name }}</div>
          <div class="col-12 col-md-6 col-lg-1">{{ item.city.name }}</div>
          <div class="col-12 col-md-6 col-lg-1">
            {{ item.address }}<br>
            <small><a
              :href="item.link"
              target="_blank">Схема проезда</a></small>
            <small class="text-muted">Часовой пояс +{{ item.tzOffset }}</small>
          </div>
          <div class="col-2 col-md-6 col-lg-1">
            <span
              v-for="(user, index) in item.users"
              class="badge badge-info">
              <router-link :to="{ name: 'ViewProfile', params: { id: user.id }}">{{ user.fullname }}</router-link>
            </span>
          </div>
          <div class="col-12 col-md-6 col-lg-1">{{ item.schedule }}</div>
          <div class="col-12 col-md-6 col-lg-1">
            <small>{{ item.phone | phoneRuFormatting }}</small>
          </div>
          <div class="col-12 col-md-6 col-lg-1">
            <span
              v-if="item.enabled"
              class="badge badge-success">Активен</span>
            <span
              v-else
              class="badge badge-danger">Заблокирован</span>
          </div>
          <div class="col-12 col-md-6 col-lg-2">
            <loading
              v-if="blockLoading === item.id"
              :size="2"
              :message="false"/>
            <template v-else>
              <router-link
                v-if="currentUser.hasPermission('techcenter.update')"
                class="btn btn-primary btn-sm"
                :to="{ name: 'TechcenterEdit', params: { id: item.id }}">
                <i class="fa fa-edit"/> Изменить
              </router-link>
              <template v-if="currentUser.isAdmin">
                <button
                  v-if="item.enabled"
                  class="btn btn-danger btn-sm"
                  @click="block(item, false)">
                  <i class="fa fa-lock"/> Заблокировать
                </button>
                <button
                  v-else
                  class="btn btn-secondary btn-sm"
                  @click="block(item, true)">
                  <i class="fa fa-unlock"/> Разблокировать
                </button>
              </template>
            </template>
          </div>
        </template>
      </admin-list>
      <template slot="footer">
        <admin-pagination
          v-model="page"
          :paginator="itemsPage.paginator"
        />
      </template>
    </admin-card>
  </div>
  <router-view v-else/>
</template>

<script>
  import getTechcentersQuery from '../../gql/queries/getAllTechcenters.graphql'
  import blockMutate from '../../gql/mutations/BlockTechcenter.graphql'
  import getCompaniesQuery from '../../gql/queries/getCompanies.graphql'
  import { mapActions, mapState } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import AdminCard from '../Admin/Components/AdminCard'
  import AdminFilter from '../Admin/Components/AdminFilter'
  import AdminList from '../Admin/Components/AdminList'
  import AdminPagination from '../Admin/Components/AdminPagination'
  export default {
    computed: {
      items () {
        return this.itemsPage.techcenters !== undefined ? this.itemsPage.techcenters : []
      },
      citiesOptions () {
        return this.cities ? this.cities.map((item) => {
          return {name: item.name, value: item.id}
        }) : []
      },
      companiesOptions () {
        return this.companiesList && this.companiesList.companies ? this.companiesList.companies.map((item) => {
          return {name: item.name, value: item.id}
        }) : []
      },
      ...mapState({
        cities: state => state.globalStore.cities,
        currentUser: state => state.globalStore.user
      })
    },
    name: 'Techcenters',
    components: {
      AdminPagination,
      AdminList,
      AdminFilter,
      AdminCard
    },
    data () {
      return {
        page: 1,
        itemsPage: {
          paginator: {
            total_count: 1000,
            limit: 10
          }
        },
        blockLoading: false,
        showFilter: true,
        loading: false,
        filterParams: [
          {
            name: 'Название',
            code: 'query',
            type: 'text',
            value: null
          },
          {
            name: 'Город',
            code: 'cityId',
            type: 'select',
            value: null,
            multiple: false,
            options: []
          },
          {
            name: 'Компания',
            code: 'companyId',
            type: 'select',
            value: null,
            multiple: false,
            options: []
          }
        ]
      }
    },
    methods: {
      /**
       * Блокировка/разблокировка техцентра
       * @param item
       * @param enabled
       */
      block (item, enabled) {
        this.blockLoading = item.id
        this.$apollo.mutate({
          mutation: blockMutate,
          variables: {
            id: item.id,
            enabled: enabled
          }
        }).then((data) => {
          this.addToast({
            text: 'Изменения сохранены',
            type: 'success',
            dismissAfter: 3000
          })
          this.blockLoading = false
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.blockLoading = false
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      itemsPage: {
        query: getTechcentersQuery,
        variables () {
          return {
            page: this.page,
            query: this.filterParams[0].value,
            cityId: this.filterParams[1].value,
            companyId: this.filterParams[2].value
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      },
      companiesList: {
        query: getCompaniesQuery,
        variables: {
          all: true
        },
        update: (data) => {
          return data
        }
      }
    },
    created () {
      this.filterParams[1].options = this.citiesOptions
      this.filterParams[2].options = this.companiesOptions
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?0c8e4da7